import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { ScheduledCashJournalCompleteContent } from './Content/ScheduledCashJournalCompleteStepContent';
import ScheduledCashJournalCompleteOverride from './metaOverrideSet';

const ScheduledCashJournalComplete = ({ className, resource }) => {
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      history.push('/');
    }
  };

  const hasRedirect = hasRelationship(resource, fr.relationships.redirect.name);
  const hasNext = resource.meta().canPost();

  const onNext = async () => {
    await loadPageContentLink(resource.relationship(fr.relationships.redirect.name).link('related'));
  };

  return (
    <WizardStepWrapperTemplate
      className={className}
      layout={ScheduledCashJournalCompleteContent}
      metaOverrideSet={ScheduledCashJournalCompleteOverride}
      LayoutProps={{ resource }}
      resource={resource}
      onNext={(!hasNext && hasRedirect) ? onNext : undefined}
      onClose={onClose}
    />
  );
};

ScheduledCashJournalComplete.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.resource),
};

export default ScheduledCashJournalComplete;
